var _desc, _defs, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarkaBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1920px",
    height: "1920px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "barka-bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barka-bg",
    transform: "translate(960.000000, 960.000000) scale(1, -1) translate(-960.000000, -960.000000) ",
    fillRule: "nonzero"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E1F3FD",
    x: 0,
    y: 0,
    width: 1920,
    height: 1920
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#BBE5FB",
    opacity: 0.602299,
    style: {
      mixBlendMode: "multiply"
    },
    points: "0 1329 1920 1588 1920 1920 0 1920"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#BBE5FB",
    opacity: 0.602299,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(960.000000, 295.500000) scale(-1, -1) translate(-960.000000, -295.500000) ",
    points: "0 0 1920 259 1920 591 0 591"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#BBE5FB",
    opacity: 0.597712054,
    style: {
      mixBlendMode: "multiply"
    },
    points: "0 332 1164 489 862.702703 1920 0 1920"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#BBE5FB",
    opacity: 0.597712054,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(582.000000, 244.500000) scale(1, -1) translate(-582.000000, -244.500000) ",
    points: "0 157 1164 -1.13686838e-13 862.702703 489 0 489"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarkaBg);
export default __webpack_public_path__ + "static/media/barka-bg.357e5b82.svg";
export { ForwardRef as ReactComponent };